import React from "react";
import Lottie from "lottie-react";
import loaderRombo from "../../assets/lotties/Loader_Rombo.json";

const LoaderRombo = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
      <Lottie
        autoplay
        loop
        animationData={loaderRombo}
        style={{ height: '150px', width: '150px' }}
      />
    </div>
  );
};

export default LoaderRombo;
